import {
  Box,
  Drawer,
  DrawerBody,
  DrawerCloseButton,
  DrawerContent,
  DrawerHeader,
  DrawerOverlay,
  Heading,
  Text,
} from '@chakra-ui/react';
import { SupplierInquiry } from '@texas/api/endpoints/inquiryApi';
import { useMetadata } from '@texas/hooks/metadata/useMetadata';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { InquiryMetadataForm } from './InquiryMetadataForm';
import { inquiryEvents } from './events';
import {
  MetadataList,
  MetadataListRow,
} from '@texas/components/shared/MetadataList';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  inquiry: SupplierInquiry;
}

export function InquiryChargesDrawer({ isOpen, onClose, inquiry }: Props) {
  const { t } = useTranslation();
  const {
    currenciesData: [, getCurrencies],
    useCurrenciesData: { findCurrency },
  } = useMetadata();

  useEffect(() => {
    getCurrencies();
  }, [getCurrencies]);

  function handleUpdated() {
    inquiryEvents.onUpdated.dispatch();
    onClose();
  }

  return (
    <Drawer isOpen={isOpen} onClose={onClose} size="md">
      <DrawerOverlay />
      <DrawerContent bg="texas.bg.900" _light={{ bg: 'gray.10' }}>
        <DrawerCloseButton />
        <DrawerHeader>{t('inquiry.charges')}</DrawerHeader>
        <DrawerBody>
          {inquiry.supplierPurchaseInfo && (
            <Box mt={6}>
              <Heading
                size="xs"
                textTransform="uppercase"
                letterSpacing="wide"
                color="gray.400"
                mb={3}
              >
                {t('inquiry.supplierPurchaseInfo')}
              </Heading>
              <MetadataList>
                <MetadataListRow label={t('inquiry.exchangeRate')}>
                  <Text fontSize="sm">
                    {String(inquiry.supplierPurchaseInfo.exchangeRate)}
                  </Text>
                </MetadataListRow>
                <MetadataListRow label={t('general.currency')}>
                  <Text fontSize="sm">
                    {findCurrency(inquiry.supplierPurchaseInfo.currencyId)
                      ?.name ?? '—'}
                  </Text>
                </MetadataListRow>
              </MetadataList>
            </Box>
          )}
          <Box>
            <Heading
              size="xs"
              textTransform="uppercase"
              letterSpacing="wide"
              color="gray.400"
              mb={3}
            >
              {t('inquiry.charges')}
            </Heading>
          </Box>
          <InquiryMetadataForm inquiry={inquiry} onUpdated={handleUpdated} />
        </DrawerBody>
      </DrawerContent>
    </Drawer>
  );
}
